<template>
  <Page>
    <section class="pluslimit-container">
      <div class="bg" />
      <div class="content" @click="qrcodeFlag = !qrcodeFlag">
        <img src="./images/bg.svg" alt="" />
        <span>您的功能访问受限啦！如有需要请联系客服哦～</span>
      </div>
    </section>

    <section class="pluslimit-qrcode-container" @click="qrcodeFlag = !qrcodeFlag" v-if="qrcodeFlag">
      <img src="./images/qrcode.jpeg" alt="" />
    </section>
  </Page>
</template>

<script setup>
  import {onMounted, ref, watch} from 'vue';
  import Page from '@/components/page';

  const qrcodeFlag = ref(false)
</script>

<style scoped lang="less">
@import "./index.less";
</style>